export default "__VITE_ASSET__C2_Tx_re__"